export class WorkflowRequestSearchDTO {
    searchAuditFirmIds: string;
    searchCompanyIds: string;
    searchDeptIds: string;
    searchSiteIds: string;
    freeSearch: string;
    wfType: string;
    approvalStatusType: string;
    auditProgramIds: string;
    workflowRemarks: string;

}